import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { RichiestaModuloDTOStatoValidazione } from '@framework/api-client';
import { theme } from 'antd';
import React from 'react';

export interface IModuleValidationStateBadgeProps {
  validationState: RichiestaModuloDTOStatoValidazione | null | undefined;
}

export function ModuleValidationStateBadge(
  props: IModuleValidationStateBadgeProps,
) {
  const { validationState } = props;

  const { token } = theme.useToken();

  if (!validationState) return null;

  if (validationState.valido != null) {
    return validationState.valido ? (
      <CheckCircleFilled style={{ color: token.colorSuccess }} />
    ) : (
      <CloseCircleFilled style={{ color: token.colorError }} />
    );
  }
  return null;
}
